// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { XhrHttpClient as DefaultHttpClient } from "./xhrHttpClient";
